import { useState, useEffect, useCallback, useRef } from 'react';

export function useAlertMessages(timeout = 20000) {
    const [error, setError] = useState<string | null>(null);
    const [successMsg, setSuccessMsg] = useState<string | null>(null);
    const alertRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!error && !successMsg) return;
        alertRef.current?.focus();
        const t = setTimeout(() => { setError(null); setSuccessMsg(null); }, timeout);
        return () => clearTimeout(t);
    }, [error, successMsg, timeout]);

    const clearAll = useCallback(() => { setError(null); setSuccessMsg(null); }, []);

    return { error, successMsg, setError, setSuccessMsg, clearAll, alertRef };
}
